import { InputSearch } from "components/ui/inputs/InputSearch"
import { PageTeamHeader } from "./layout/PageTeamHeader/PageTeamHeader"
import { TeamTable } from "./layout/TeamTable/TeamTable"
import { useUsers } from "hooks/api/user/user.hook"
import { Skeleton } from "components/ui/skeleton/Skeleton"
import style from "./PageTeam.module.scss"

const { pageTeam, container } = style

export const PageTeam = () => {
	const { data: allUsers, isPending: isUsersPending } = useUsers()

	return (
		<section className={pageTeam}>
			<div className={container}>
				<PageTeamHeader />
				{isUsersPending ? (
					<Skeleton rows={8} />
				) : (
					<>
						<InputSearch disabled={true} />
						<TeamTable allUsers={allUsers} />
					</>
				)}
			</div>
		</section>
	)
}
